// Tema claro/oscuro. Igual que el ERP: el valor va en <html data-tema> y los
// tokens de estilos.css giran solos. Por defecto sigue al sistema.
export type Tema = "claro" | "oscuro" | "sistema";
const LLAVE = "victorix-chat-ai:tema";

export function temaGuardado(): Tema {
  const v = localStorage.getItem(LLAVE);
  return v === "claro" || v === "oscuro" ? v : "sistema";
}

export function aplicarTema(t: Tema) {
  const oscuro = t === "oscuro" ||
    (t === "sistema" && window.matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.dataset.tema = oscuro ? "oscuro" : "claro";
  if (t === "sistema") localStorage.removeItem(LLAVE); else localStorage.setItem(LLAVE, t);
}

export function iniciarTema() {
  aplicarTema(temaGuardado());
  window.matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", () => { if (temaGuardado() === "sistema") aplicarTema("sistema"); });
}

// ── Escala en pantallas muy grandes ─────────────────────────────────────────
// En un monitor 1440p o 4K sin escalado del sistema, una interfaz de 15 px se
// ve diminuta. Se sube la escala por pasos con `zoom`, que agranda TODO
// (incluidos los tamaños en px) manteniendo las proporciones.
// A propósito NO se hace con @media, para que la escala dependa solo del ancho
// REAL de la ventana. ⚠️ El zoom NO cambia `innerWidth` (medido en Chrome 156:
// 1920 con zoom 1.15): multiplicar innerWidth por el zoom vigente, como se hacía,
// subía un paso en cada resize (1.15 → 1.4 en una ventana de 2100).
// ⚠️ El zoom SÍ multiplica dvh/vh: por eso se publica --escala y las pantallas
// completas usan `h-pantalla` (estilos.css), que divide por ella.
const PASOS: [number, number][] = [[3400, 1.7], [2400, 1.4], [1900, 1.15]];

export function escalaPara(anchoVentana: number): number {
  const paso = PASOS.find(([min]) => anchoVentana >= min);
  return paso ? paso[1] : 1;
}

export function ajustarEscala() {
  const aplicar = () => {
    const raiz = document.documentElement;
    const z = escalaPara(window.innerWidth);
    if (z === 1) {
      raiz.style.removeProperty("zoom");
      raiz.style.removeProperty("--escala");
    } else {
      raiz.style.zoom = String(z);
      raiz.style.setProperty("--escala", String(z));
    }
  };
  aplicar();
  window.addEventListener("resize", aplicar);
}
